import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { AccessControlService } from "app/access-control/access-control-service";
import { hasAccess } from "app/access-control/permission-verification";
import { ProviderPanel } from "app/access-control/permissions";
import { IUser } from "app/auth/user.model";
import {
  Events,
  IonicPage,
  LoadingController,
  ModalController,
  NavParams,
} from "ionic-angular";
import * as moment from "moment-timezone";
import { ResourceManagementService } from "providers/resource-management/resource-management.service";
import { Subscription } from "rxjs";
import { Observable } from "rxjs/Observable";
import { AuthService } from "../../../app/auth/auth.service";
import { NavigationService } from "../../../navigation/navigation.service";
import { NavigationDataService } from "../../../navigation/services/navigation-data.service";
import {
  AppStatus,
  ConnectionStatusEnum,
} from "../../../providers/app-status/app-status";
import { CalendarService } from "../../../providers/calendar-service/calendar-service";
import { ConfigurationService } from "../../../providers/configuration/configuration.service";
import { MasterDataService } from "../../../providers/master-data-service/master-data-service";
import { MobileOfflineDataProvider } from "../../../providers/mobile-offline-data/mobile-offline-data";
import { MobileUtilsProvider } from "../../../providers/mobile-utils/mobile-utils";
import { DatabaseProvider } from "../../../providers/offline-database/db-connection";
import { PatientDataManager } from "../../../providers/offline-manager/patient-data-manager";
import { StateManagementService } from "../../../providers/state-management/state-management.service";
import { UtilityService } from "../../../providers/utility-service/utility-service";
import { BasePage } from "../../base-page";
import { TaskDetailsTableComponent } from "./task-details-table/task-details-table";
@IonicPage({
  name: "dashboard-page",
})
@Component({
  selector: "page-dashboard",
  templateUrl: "dashboard.html",
})
export class DashboardPage extends BasePage implements OnInit, OnDestroy {
  calendarSubscription: Subscription = new Subscription();
  patientChartId: number;

  patChartId: number;
  teamsData = <any>{};
  team: {};
  patientData: {};
  patientsFetching: boolean = true;
  isTeamLoaded: boolean = false;
  userHasTeams: boolean = false;
  landingCard: boolean = false;
  userDisciplines: boolean = false;
  bereavementDisciplines: boolean = false;
  isPatientLoaded: boolean = false;
  teamSet: boolean = true;
  currentPage = 0;
  pageLimit: number = 10;
  idgDataUrl: string;
  assessmentUrl: string;
  patientProfileUrl: string;
  teamId: number = 0;
  teamPatientsCount: number = 0;
  currentDate: any;
  currentTime: any;
  currentDay: any;
  visitCount: number = 0;
  calendarStatus: boolean;
  spinnerCounter = 0;
  spinner = null;
  clock: any;
  patientOfflineData: object = {};
  appSyncStatus: ConnectionStatusEnum;
  connectionStatusEnum = ConnectionStatusEnum;
  isMobilePlatform: boolean = false;
  mobileOnly: boolean = false;
  private newPatientProfileBaseUrl: string;
  private newPatientChartUrl: string;
  private newPatientChartData: any;
  public avatarSrc: string = "assets/mantis/silhouette.jpg";
  schedulingUrl: string;

  get doShowPhysicianPanelButton() {
    return (
      (this.userDisciplines === true || this.isSupportUser) &&
      this.showOrderManagement
    );
  }

  orderEntryToggle = false;
  oeProviderPanelToggle = false;
  physicianPanelText = "";
  imgPhysicianProviderPanelText: string = "";

  user: IUser | undefined;
  isSupportUser = false;

  constructor(
    public loadingCtrl: LoadingController,
    public navSvc: NavigationService,
    private http: HttpClient,
    public navParams: NavParams,
    private authSvc: AuthService,
    public stateData: StateManagementService,
    public calendarService: CalendarService,
    public modalCtrl: ModalController,
    public navData: NavigationDataService,
    private mobileUtils: MobileUtilsProvider,
    public database: DatabaseProvider,
    public mobileMasterData: MasterDataService,
    private mobileOfflineData: MobileOfflineDataProvider,
    public patientDataManager: PatientDataManager,
    public events: Events,
    public appStatus: AppStatus,
    private configurationService: ConfigurationService,
    public resourceManagementService: ResourceManagementService,
    public utilityService: UtilityService,
    protected accessControlService: AccessControlService
  ) {
    super(stateData);
    this.user = authSvc.getUser();

    this.navSvc
      .initialize()
      .then(() => {})
      .catch((error) => {
        console.error("Error initializing NavigationService:", error);
      });
    this.stateData.showOrderEntryOM.subscribe((x) => {
      this.orderEntryToggle = x;
      this.updatePhysicianPanelText();
    });
    this.stateData.showOEProviderPanel.subscribe((x) => {
      this.oeProviderPanelToggle = x;
      this.updatePhysicianPanelText();
    });

    this.idgDataUrl = configurationService.resolveIdgUrl();
    this.schedulingUrl = this.configurationService.getConfig().apiUrl;
    this.assessmentUrl = this.configurationService.getConfig().apiUrl;
    this.patientProfileUrl = this.configurationService.getConfig().logoutUrl;
    this.newPatientProfileBaseUrl =
      this.configurationService.getConfig().clinicalUrl;
    this.calendarStatus = window.localStorage["calendarStatus"];
    this.appSyncStatus = this.appStatus.getAppStatus();
    this.mobileOnly = this.mobileUtils.checkIfMobile();

    this.newPatientChartUrl = this.configurationService.resolvePatientChartsUrl();
    this.stateData.setAssessmentType("Dashboard");
    this.stateData.setSectionId("Home");
    if (this.orderEntryToggle && this.oeProviderPanelToggle) {
      this.physicianPanelText = "Provider Panel";
    } else {
      this.physicianPanelText = "Physicians Panel";
    }
  }

  @ViewChild(TaskDetailsTableComponent)
  taskDetailsTable: TaskDetailsTableComponent;

  ionViewCanEnter() {
    return this.authSvc.authenticated();
  }

  ionViewDidLoad() {
    this.setCurrentDateTime();

    // Fetch user disciplines when app is Online OR SQLite is ready in Offline
    const isOffline = this.appStatus.isOffline();
    if (!isOffline || (isOffline && this.database.isReady())) {
      if (this.authSvc.getUser()) {
        this.getUserDisciplines();
      }
    }
  }

  ionViewWillEnter() {
    this.stateData.setChartId(null);
    this.stateData.setAssessmentType(null);
    this.stateData.setAssessmentType("Dashboard");
    this.stateData.setSectionId("Home");
  }

  ionViewCanLeave(): void {
    this.events.unsubscribe("networkchange", this.onNetworkChange);
  }

  ngOnInit() {
    if (this.mobileUtils.isMobilePlatform()) {
      if (!this.database.isReady()) {
        this.database.initializeSQLiteDB().subscribe(() => {
          // Notify app.component to perform SQLite operation
          this.events.publish("sqlite-ready", true);
          // Download mobile data
          this.downloadOfflineData();
          // Load user disciplincs from SQLite when app is offline
          if (this.appStatus.isOffline()) {
            if (this.authSvc.getUser()) {
              this.getUserDisciplines();
            }
          }
        });
      } else {
        this.downloadOfflineData();
      }
      this.onNetworkChange = this.onNetworkChange.bind(this);
      this.events.subscribe("networkchange", this.onNetworkChange);
    }

    this.accessControlService
      .getPermission([ProviderPanel.DashboardSupportView])
      .subscribe((data) => {
        this.isSupportUser = hasAccess(
          ProviderPanel.DashboardSupportView,
          data.permissions
        );
      });
  }

  updatePhysicianPanelText() {
    if (this.orderEntryToggle && this.oeProviderPanelToggle) {
      this.physicianPanelText = "Provider Panel";
      this.imgPhysicianProviderPanelText =
        "Click here to access the Provider Panel";
    } else {
      this.physicianPanelText = "Physicians Panel";
      this.imgPhysicianProviderPanelText =
        "Click here to access the Physicians Panel";
    }
  }

  ngOnDestroy(): void {
    if (this.calendarSubscription) {
      this.calendarSubscription.unsubscribe();
    }
  }

  getUserDisciplines() {
    this.utilityService.increaseSpinnerCount("Loading...");
    this.stateData.checkUserDisciplines().subscribe(
      (data) => {
        if (data["persons"] && data["persons"].length > 0) {
          this.userDisciplines =
            data["persons"][0]["discipline"] === "MD" ||
            data["persons"][0]["discipline"] === "DO" ||
            data["persons"][0]["discipline"] === "PHYSICIAN";
          this.bereavementDisciplines =
            data["persons"][0]["discipline"] === "BC";
          if (data["persons"][0]["teamSet"].length > 0) {
            const teams: any = data["persons"][0]["teamSet"];
            this.teamsData.content = teams.sort((a, b) =>
              a.name.localeCompare(b.name)
            );
            this.team = this.teamsData.content[0];
            this.teamChanged(this.team);
            this.userHasTeams = true;
            this.isTeamLoaded = true;
            this.utilityService.decreaseSpinnerCount();
          } else {
            this.landingCard = true;
            this.utilityService.decreaseSpinnerCount();
          }
        } else {
          this.landingCard = true;
          this.utilityService.decreaseSpinnerCount();
        }
      },
      (error) => {
        this.landingCard = true;
        this.utilityService.decreaseSpinnerCount();
      }
    );
  }

  onNetworkChange(eventData) {
    this.appSyncStatus = eventData.status;
    if (this.appSyncStatus === ConnectionStatusEnum.Offline) {
      this.loadOfflinePatients();
    } else {
      if (this.team) {
        this.teamChanged(this.team);
      }
    }
  }

  downloadOfflineData() {
    if (this.appSyncStatus === ConnectionStatusEnum.Online) {
      this.mobileMasterData.loadMasterData();
      this.mobileOfflineData.loadInitialVisitPageData();
      this.mobileOfflineData.loadInitialVisitDetailsPageData();
    } else if (this.appSyncStatus === ConnectionStatusEnum.Offline) {
      this.loadOfflinePatients();
    }
  }

  loadOfflinePatients() {
    this.patientDataManager
      .getPatientOfflineData(this.user.userId)
      .subscribe((data) => {
        this.patientOfflineData = data;
      });
  }

  teamChanged(newTeam) {
    if (this.appStatus.isOffline()) {
      // Block HTTP call in offline mode
      return;
    }

    this.teamSet = false;
    this.isPatientLoaded = false;
    this.patientsFetching = true;
    this.teamId = newTeam.id;
    this.teamPatientsCount = newTeam.patientCount;
    this.setPatientCountDetails();
    this.getPatientsForTeamData(this.teamId).subscribe(
      (data) => {
        this.currentPage = 0;
        this.patientsFetching = false;
        this.isPatientLoaded = true;
      },
      (err) => {
        console.log(err);
        this.isPatientLoaded = true;
      }
    );
  }

  getPatientsForTeamData(teamId): Observable<any> {
    if (typeof teamId !== "undefined") {
      return new Observable((observer) => {
        try {
          let status = "On-Service,Discharged";
          if (!this.bereavementDisciplines) {
            status = "On-Service";
          }
          let headers = new HttpHeaders().set(
            "Content-Type",
            "application/json"
          );
          let params = new HttpParams()
            .set("patientStatus", status)
            .set("size", this.pageLimit.toString())
            .set("page", this.currentPage.toString())
            .set("sort", "lastName");
          this.http
            .get(
              `${this.idgDataUrl}/company-resources/userTeams/${teamId}/patients`,
              {
                headers: headers,
                params: params,
              }
            ) // this is working to retrieve list of on-service patients for On-service list
            .subscribe(
              (response) => {
                observer.next(response);
                observer.complete();
              },
              (err) => {
                observer.error(err);
                observer.complete();
              }
            );
        } catch (error) {
          console.log("Error during data submission and building.", error);
        }
      });
    }
  }

  setCurrentDateTime() {
    this.clock = setInterval(() => {
      let now = new Date();
      let days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      this.currentDate = now.toLocaleDateString();
      this.currentTime = moment(now).format("HH:mm:ss");
      this.currentDay = days[now.getDay()];
    }, 1000);
    let now = new Date();
    now.setDate(now.getDate() - 1);
  }

  getDate(dateString) {
    let date = dateString.split("-");
    return new Date(
      parseInt(date[0]),
      parseInt(date[1]) - 1,
      parseInt(date[2])
    ).setHours(0, 0, 0, 0);
  }

  setPatientCountDetails() {
    let status = "On-Service,Discharged";
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    let params = new HttpParams()
      .set("patientStatus", status)
      .set("size", this.pageLimit.toString())
      .set("page", this.currentPage.toString())
      .set("sort", "lastName");
    this.http
      .get(
        `${this.idgDataUrl}/company-resources/userTeams/${this.teamId}/patients`,
        {
          headers: headers,
          params: params,
        }
      ) // this is working to retrieve list of on-service patients for On-service list
      .subscribe(
        (data) => {
          const patientsData = data["content"];
          this.visitCount = 0;
          var now = new Date();
          now.setHours(0, 0, 0, 0);
          var yesterday = now.setDate(now.getDate() - 1);
          var startDate = moment(yesterday).format("YYYY-MM-DDT00:00:00");
          var endDate = moment(yesterday).format("YYYY-MM-DDT23:59:59");
          var queryString = `/visits/visitCount?startDate=${startDate}&endDate=${endDate}`;

          for (let patient of patientsData) {
            let admitDate = 0;
            let dischargeDate = 0;

            if (patient && patient.qbosId && patient.patientChart) {
              queryString += `&id=${patient.qbosId}`;
              if (patient.patientChart.admitDate) {
                admitDate = this.getDate(patient.patientChart.admitDate);
              }
              if (patient.patientChart.dischargeDate) {
                dischargeDate = this.getDate(
                  patient.patientChart.dischargeDate
                );
              }
            }
          }

          if (patientsData.length > 0) {
            this.getVisitCount(queryString).subscribe(
              (data) => {
                this.visitCount = data.count;
              },
              (err) => {
                console.log(err);
              }
            );
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getVisitCount(qString): Observable<any> {
    if (typeof qString !== "undefined") {
      return new Observable((observer) => {
        try {
          let headers = new HttpHeaders().set(
            "Content-Type",
            "application/json"
          );
          this.http
            .get(this.assessmentUrl + qString, { headers: headers })
            .subscribe(
              (response) => {
                observer.next(response);
                observer.complete();

                observer.next(response);
                observer.complete();
              },
              (err) => {
                observer.error(err);
                observer.complete();
              }
            );
        } catch (error) {
          console.log("Error during data submission and building.", error);
        }
      });
    }
  }

  redirectPage(page) {
    if (
      this.doShowPhysicianPanelButton &&
      this.orderEntryToggle &&
      this.oeProviderPanelToggle
    ) {
      this.navSvc.goToInternalPage("ProviderPanelPage", {});
      return;
    }

    if (page === "CalendarPage" && this.isNewCal) {
      this.navSvc.goToInternalPage("NewCalendarPage", { patChartId: 0 });
    } else if (page === "CalendarPage") {
      this.navSvc.goToInternalPage("CalendarPage", { patChartId: 0 });
    } else {
      this.navSvc.goToInternalPage(page, {});
    }
  }

  goToPatientProfile(chartId) {
    if (this.mobileUtils.isMobilePlatform()) {
      this.navSvc.goToInternalPage("VisitsPage", { patChartId: chartId });
    } else {
      let patientChartUrl = `${this.newPatientChartUrl}/patient-charts/${chartId}?externalId=true`;
      const promise = this.http.get(patientChartUrl).toPromise();
      promise
        .then((data) => {
          let resourceUrl = `${
            this.patientProfileUrl
          }/clinical/patientchart/index/${chartId}?tenantId=${
            this.authSvc.getUser().tenantId
          }`;
          if (this.showNewPatientChartAsValue()) {
            this.newPatientChartData = data;
            let resourceUrl = `${
              this.newPatientProfileBaseUrl
            }#/referral-tabs/${this.convertStatusUrlSection(
              this.newPatientChartData.patientStatus
            )}/patient-details/patient-details/${this.newPatientChartData.id}`;
            window.location.replace(resourceUrl);
          } else {
            window.location.replace(resourceUrl);
          }
        })
        .catch((error) => {
          console.log(
            "Error: Feature Toggle not available  -> " + JSON.stringify(error)
          );
          window.location.replace(
            `${
              this.patientProfileUrl
            }/clinical/patientchart/index/${chartId}?tenantId=${
              this.authSvc.getUser().tenantId
            }`
          );
        });
    }
  }

  public convertStatusUrlSection(patientStatus: string) {
    if (patientStatus.toLowerCase() == "on-service") {
      return "patient";
    }
    if (patientStatus.toLowerCase() == "discharged") {
      return "discharge";
    }
    return patientStatus.toLowerCase();
  }

  protected showNewPatientChartAsValue(): boolean {
    return this.stateData.isPatientChart.getValue();
  }
}



// WEBPACK FOOTER //
// ./src/pages/common/dashboard/dashboard.ts